import React from "react";
import GamePayment from "components/Payment/GamePayment";
import { showAuxiliaryDialog } from "components/SharedComponents/AuxiliaryDialog";
import { Game } from "types/game";
import { getPaymentDialogSubtitle, getPaymentDialogTitle } from "./paymentDialogMeta";

/** Opens Stripe Checkout join flow for pay-before-play games (card-only for players). */
export function openPayBeforeJoinPayment(game: Game, onPaymentComplete?: () => void): void {
  showAuxiliaryDialog(
    <GamePayment
      type="pay"
      game={game}
      payBeforeJoin={true}
      onPaymentComplete={onPaymentComplete}
    />,
    "xl",
    true,
    true,
    true,
    getPaymentDialogTitle(game),
    false,
    getPaymentDialogSubtitle(game),
  );
}
